/**
 * 顶部公告条文案。
 *
 * `id` 参与 localStorage 键（`havorix.announcement.<id>`）：换 id 等于换一条公告，
 * 之前关掉过的访客会重新看到。
 */
export const ANNOUNCEMENT = {
  id: 'coming-soon-2026',
  text: '四款新产品正在规划中：物联网平台、风场预测平台、网络 RTK 与 4G 健康管理板。',
  action: { label: '查看规划', to: '/products#coming-soon' },
} as const;
